import React, { useState, useEffect } from "react";
import logopreto from "../../images/logopreto.svg";
import vetor from "../../images/vetor.gif";
import smartphone from "../../images/smartphone.gif";
import marketing from "../../images/marketing.gif";
import html from "../../images/html.gif";
import imgsection from "../../images/imgsection.svg";
import responsivo from "../../images/responsivo.png";
import socialmedia from "../../images/socialmedia.png";
import whatsapp from "../../images/whatsapp.png";
import design from "../../images/design.png";
import Footer from "../../components/Footer";
import { FaArrowUp, FaGithub } from "react-icons/fa";
import { Fade, Zoom } from "react-awesome-reveal";
import {
  Container,
  PageNew,
  SecondSection,
  Title,
  ScrollButton,
  Button,
  HighlightTitle,
  HighlightDescription,
  HighlightItem,
  HighlightsSection,
  NewSection,
  Image,
  Text,
  Paragrafo,
  WhatsAppButton,
  NewSectionDesign,
  TextDesign,
  ParagrafoDesign,
  ButtonDesign,
  ButtonGit,
} from "./HomeStyles";

const mensagem =
  "Deixe a sua mensagem e aguarde! Estamos transformando ideias em sites incríveis.";

const Home = () => {
  const [showButton, setShowButton] = useState(false);

  const handleScroll = () => {
    if (window.pageYOffset > 200) {
      setShowButton(true);
    } else {
      setShowButton(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleClick = () => {
    window.location.href = "https://github.com/devs-joabe";
  };

  return (
    <>
      <Container>
        <PageNew>
          <div className="pagenew">
            <Fade bottom>
              <h2>Transformando</h2>
            </Fade>
            <Fade bottom delay={300}>
              <span>ideias em sites incríveis.</span>
            </Fade>
            <Fade bottom delay={600}>
              <p>
                Soluções digitais personalizadas para impulsionar seu negócio.
              </p>
            </Fade>
            <Fade bottom delay={400}>
              <ButtonGit onClick={handleClick}>
                <FaGithub style={{ marginRight: "10px" }} /> Acessar
              </ButtonGit>
            </Fade>
          </div>
        </PageNew>
        <div className="painel">
          <Zoom>
            <img src={logopreto} alt="Logo" />
          </Zoom>
        </div>
      </Container>

      <SecondSection className="section">
        <div>
          <img src={imgsection} alt="Logo" />
        </div>
        <Title>Impulsionando Negócios por Meio de Sistemas Digitais</Title>
        <Button>Saiba mais</Button>
        <Fade cascade direction="left">
          <HighlightsSection>
            <HighlightItem>
              <div className="gif">
                <img src={vetor} alt="Design Gráfico" />
              </div>
              <HighlightTitle>Design Gráfico</HighlightTitle>
              <HighlightDescription>
                Criamos designs gráficos personalizados para suas necessidades,
                desde logotipos até materiais promocionais.
              </HighlightDescription>
            </HighlightItem>
            <HighlightItem>
              <div className="gif">
                <img src={html} alt="Design Gráfico" />
              </div>
              <HighlightTitle>Desenvolvimento Web</HighlightTitle>
              <HighlightDescription>
                Criamos websites responsivos e de alta qualidade, utilizando as
                tecnologias mais recentes e práticas recomendadas.
              </HighlightDescription>
            </HighlightItem>
            <HighlightItem>
              <div className="gif">
                <img src={marketing} alt="Design Gráfico" />
              </div>
              <HighlightTitle>Marketing Digital</HighlightTitle>
              <HighlightDescription>
                Ajudamos você a impulsionar sua presença online, com estratégias
                eficazes de marketing digital, SEO e mídia social.
              </HighlightDescription>
            </HighlightItem>
            <HighlightItem>
              <div className="gif">
                <img src={smartphone} alt="Design Gráfico" />
              </div>
              <HighlightTitle>Social Media</HighlightTitle>
              <HighlightDescription>
                Deixe-nos cuidar das suas redes sociais enquanto você foca no
                que faz de melhor. Junte-se a nós e alcance novos horizontes
                digitais!
              </HighlightDescription>
            </HighlightItem>
          </HighlightsSection>
        </Fade>
        <NewSection>
          <Image src={responsivo} alt="Imagem" />
          <Text>
            Sistemas Responsivos:
            <Paragrafo>Adaptando-se a</Paragrafo>
            <Paragrafo>Todos os Dispositivos</Paragrafo>
            <Button>Saiba mais</Button>
          </Text>
        </NewSection>
        <NewSectionDesign>
          <Image src={design} alt="Imagem" />
          <TextDesign>
            Desenhando a Imaginação:
            <ParagrafoDesign> Explorando o Mundo</ParagrafoDesign>
            <ParagrafoDesign>do Design Gráfico</ParagrafoDesign>
            <ButtonDesign>Saiba mais</ButtonDesign>
          </TextDesign>
        </NewSectionDesign>
        <NewSection>
          <Image src={socialmedia} alt="Imagem" />
          <Text>
            Sucesso Digital:
            <Paragrafo>Navegando no Mundo</Paragrafo>
            <Paragrafo>do Marketing Digital</Paragrafo>
            <Button>Saiba mais</Button>
          </Text>
        </NewSection>
      </SecondSection>

      {showButton && (
        <ScrollButton onClick={scrollToTop}>
          <FaArrowUp />
        </ScrollButton>
      )}

      <WhatsAppButton
        href={`https://api.whatsapp.com/send?phone=75991016263&text=${encodeURIComponent(
          mensagem
        )}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={whatsapp} alt="WhatsApp" />
      </WhatsAppButton>

      <Footer />
    </>
  );
};

export default Home;
